/**
 * normalize_image の単体テスト (TGW-915 / 本人確認 Chrome・Firefox対応)
 *
 * Chrome/Firefox は HEIC をネイティブにデコードできず createImageBitmap が失敗する。
 * そのため HEIC の場合は先に heic2any(libheif) で JPEG 化してから canvas 正規化に渡す。
 * createImageBitmap / canvas は jsdom 未実装のためモックして分岐のみを検証する。
 */

import normalizeImage from './normalize_image';
import { isHeic, convertHeicToJpeg } from '../../../lib/image_compressor';

jest.mock('../../../lib/image_compressor', () => ({
  isHeic: jest.fn(),
  convertHeicToJpeg: jest.fn(),
}));

beforeEach(() => {
  jest.clearAllMocks();

  // createImageBitmap は jsdom 未実装のためモック
  global.createImageBitmap = jest.fn(async () => ({
    width: 100,
    height: 80,
    close: jest.fn(),
  }));

  // canvas も jsdom では getContext が null を返すためモック
  const ctx = { drawImage: jest.fn() };
  const canvas = {
    getContext: jest.fn(() => ctx),
    toBlob: (cb) => cb(new Blob(['jpeg-bytes'], { type: 'image/jpeg' })),
  };
  jest
    .spyOn(document, 'createElement')
    .mockImplementation((tag) => (tag === 'canvas' ? canvas : {}));
});

afterEach(() => {
  delete global.createImageBitmap;
  jest.restoreAllMocks();
});

describe('normalizeImage HEIC対応 (TGW-915)', () => {
  test('file が無ければ null を返す', async () => {
    expect(await normalizeImage(null)).toBeNull();
  });

  test('HEIC は convertHeicToJpeg で変換してから canvas 処理に渡す', async () => {
    isHeic.mockReturnValue(true);
    const jpegFile = new File(['j'], 'converted.jpg', { type: 'image/jpeg' });
    convertHeicToJpeg.mockResolvedValue(jpegFile);
    const heic = new File(['h'], 'IMG_0001.heic', { type: 'image/heic' });

    const result = await normalizeImage(heic, 'selfie.jpg');

    expect(convertHeicToJpeg).toHaveBeenCalledWith(heic);
    // createImageBitmap には元のHEICではなく変換後のJPEGが渡る
    expect(global.createImageBitmap).toHaveBeenCalledWith(
      jpegFile,
      expect.anything(),
    );
    expect(result).toBeInstanceOf(File);
    expect(result.type).toBe('image/jpeg');
    expect(result.name).toBe('selfie.jpg');
  });

  test('非HEIC は変換せず元ファイルをそのまま処理する', async () => {
    isHeic.mockReturnValue(false);
    const jpg = new File(['j'], 'photo.jpg', { type: 'image/jpeg' });

    await normalizeImage(jpg);

    expect(convertHeicToJpeg).not.toHaveBeenCalled();
    expect(global.createImageBitmap).toHaveBeenCalledWith(
      jpg,
      expect.anything(),
    );
  });
});
